/** Global pull default. Per-query overrides live next to each query. */
export const DEFAULT_STALE_TIME = 60_000

/** Session and permissions change rarely but must not go stale for a whole day. */
export const SESSION_STALE_TIME = 5 * 60_000

/**
 * The session's query key. It lives here rather than beside `sessionQuery`
 * because a feature may not import from `app/`, and three of them have to
 * invalidate the session after a mutation — a subscription starting, a
 * password changing, a campaign counting against a plan limit. Spelled as a
 * literal in each of those, it was four copies of a string with nothing
 * keeping them equal.
 */
export const SESSION_QUERY_KEY = ['session'] as const

/** Data a stream owns is never polled — push is the only freshness source. */
export const STREAM_STALE_TIME = Number.POSITIVE_INFINITY

/**
 * A counter with no stream behind it has to poll, and this is how often. Thirty
 * seconds is a compromise between a number that is visibly wrong and a request
 * every few seconds for a figure nobody is watching that closely; it only runs
 * while the tab is visible.
 */
export const STATS_REFETCH_MS = 30_000

/** Keystrokes are not navigations. */
export const SEARCH_DEBOUNCE_MS = 300

/** Leading-edge window for coalescing a burst of stream events. */
export const STREAM_COALESCE_MS = 100

export const THEME_STORAGE_KEY = 'ui-theme'
export const QUERY_CACHE_STORAGE_KEY = 'query-cache'

/**
 * Only these query key roots may be written to localStorage. Anything carrying
 * personal or payment data must never appear here.
 */
export const PERSISTED_QUERY_ROOTS: readonly string[] = ['dictionaries']
